import Grid from "@mui/material/Grid";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import InputWrapper from "../../inputs/shared/InputWrapper";

const RffInputWrapper = ({
  label,
  children,
  suppressGrid,
  sx = {},
  size = 12,
  fullWidth = true,
  row = false,

  helperText,
  required,
}) => {
  const gridSizeProps = useMemo(() => {
    return {
      xs: 12,
      sm: 12,
      md: size,
      lg: size,
      xl: size,
    };
  }, [size]);

  if (suppressGrid) {
    return (
      <RenderedContent
        sx={sx}
        helperText={helperText}
        label={label}
        row={row}
        fullWidth={fullWidth}
        required={required}
      >
        {children}
      </RenderedContent>
    );
  }

  return (
    <Grid item {...gridSizeProps} sx={sx}>
      <RenderedContent
        helperText={helperText}
        label={label}
        row={row}
        fullWidth={fullWidth}
        required={required}
      >
        {children}
      </RenderedContent>
    </Grid>
  );
};

const RenderedContent = ({
  label,
  helperText,
  sx,
  children,
  required,
  fullWidth,
  row,
}) => {
  const styles = useMemo(() => {
    let initStyles = {
      flexShrink: 0,
    };

    return {
      ...initStyles,

      ...sx,
    };
  }, [sx]);

  if (isNil(label)) {
    return children;
  }
  return (
    <InputWrapper
      fullWidth={fullWidth}
      sx={styles}
      helperText={helperText}
      label={label}
      required={required}
      row={row}
    >
      {children}
    </InputWrapper>
  );
};

export default RffInputWrapper;
